var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x8A\xB8\xEC\x9C\x84\xED\x84\xB0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5 6.58589V23.4149C29.5 26.7759 26.776 29.5 23.4151 29.5H6.5865C3.22479 29.5 0.5 26.7752 0.5 23.4133V6.58589C0.5 3.2248 3.22483 0.5 6.58495 0.5H23.4151C26.776 0.5 29.5 3.22407 29.5 6.58512V6.58589Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7512 5.93024H23.818L17.118 13.6141L25 24.0698H18.8284L13.9945 17.7284L8.46359 24.0698H5.39484L12.5614 15.8513L5 5.93024H11.3283L15.6977 11.7264L20.7512 5.93024ZM19.6747 22.2279H21.3742L10.405 7.67536H8.58125L19.6747 22.2279Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsX);
export default __webpack_public_path__ + "static/media/sns_x.7dec62dc486326fbf3d4a1d995f898fe.svg";
export { ForwardRef as ReactComponent };